/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { useState } from 'react';
import ModalRequestPath from '../../controls/ModalRequestPath';
import { Redirect } from 'react-router-dom';
import Tools from '../../tools/tools';

const RequestRow = ({ item, deleteFunc }) => {
    let [showRequestPathId, setShowRequestPathId] = useState();
    let [showPath, setShowPath] = useState(false);
    let [showRequest, setShowRequest] = useState(null);


    const Show = (requestId) => {

        setShowRequest(requestId);
    }

    const ShowPath = (requestId) => {
        setShowRequestPathId(requestId);
        console.log("show");
        setShowPath(true);
    }

    if (showRequest) {
        sessionStorage.setItem("requestId", showRequest);
        return (<Redirect to={"RequestMain/" + showRequest} />);
    }


    return (

        <div className="row">
            <div className="col-md-2">{item.givenToName}</div>
            <div className="col-md-1"><small>{Tools.FormatDate(item.createdOn)}</small></div>
            <div className="col-md-1">{item.objectNumber}</div>
            <div className="col-md-2">
                {item.objectName}
                <button className="btn btn-link" onClick={() => Show(item.requestId)}>{item.num}</button>
                <button className="btn btn-primary" onClick={() => ShowPath(item.requestId)}>Път</button>
            </div>
            <div className="col-md-2"><small>{item.requestState}</small></div>
            <div className="col-md-2"><small>{item.requestType}</small></div>
            <div className="col-md-2"><small>{item.ekatte && JSON.parse(item.ekatte).map(i => <span key={'s' + i.type}><b>{i.type}:</b> {i.name} </span>)}</small></div>
            <ModalRequestPath display={showPath} requestId={showRequestPathId} closeFunc={() => setShowPath(false)} />
        </div>
    )
}

export default RequestRow;


